import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(items: any[], filter: string): any {
      if (!items || !filter) {
      return items;
    }

    return items.filter(item =>JSON.stringify(item).toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1899679744/src/src/app/shared/pipes/search.pipe.ts